import { Activity } from "@outschool/gql-backend-generated";
import {
  IconDefinition,
  faBooks,
  faCalendarDay,
  faMessageLines,
  faMessages,
  faPersonChalkboard,
  faPlayPause,
  faPresentation,
  faUnlock,
  faUsers,
} from "@outschool/icons";
import React from "react";

import usePriceDetailsString from "./hooks/usePriceDetailsString";
import { IconBullet } from "./PriceDetailsComponents";

import type { SelfPacedNumberOfLessonsActivityType } from "./hooks/usePriceDetailsString";

export const GROUPS_CLASS_TYPE_ICON = faMessages;
export const SELF_PACED_CLASS_TYPE_ICON = faPresentation;
export const TUTORING_CLASS_TYPE_ICON = faPersonChalkboard;
export const GROUP_CLASSES_CLASS_TYPE_ICON = faUsers;
export function getClassTypeIcon(activity: {
  isSelfPaced: boolean;
  isClub: boolean;
  size_max: number | null;
}): IconDefinition {
  if (activity.isClub) {
    return GROUPS_CLASS_TYPE_ICON;
  } else if (activity.isSelfPaced) {
    return SELF_PACED_CLASS_TYPE_ICON;
  } else if (activity.size_max === 1) {
    return TUTORING_CLASS_TYPE_ICON;
  } else {
    return GROUP_CLASSES_CLASS_TYPE_ICON;
  }
}

export type SelfPacedIconInfoActivityType =
  SelfPacedNumberOfLessonsActivityType & Pick<Activity, "duration_weeks">;

export function useSelfPacedIconInfo(activity: SelfPacedIconInfoActivityType) {
  const {
    selfPacedNumberOfLessonsString,
    selfPacedWeeksOfFeedbackString,
    selfPacedAccessToContentString,
    selfPacedChooseStartTimeString,
    selfPacedStartAndLearnString,
  } = usePriceDetailsString();

  return {
    numberOfLessons: {
      icon: faBooks,
      text: selfPacedNumberOfLessonsString(activity),
    },
    startAndLearn: {
      icon: faPlayPause,
      text: selfPacedStartAndLearnString(),
    },
    weeksOfFeedback: {
      icon: faMessageLines,
      text: selfPacedWeeksOfFeedbackString(activity),
    },
    chooseStartTime: {
      icon: faCalendarDay,
      text: selfPacedChooseStartTimeString(),
    },
    accessToContent: {
      icon: faUnlock,
      text: selfPacedAccessToContentString(),
    },
  };
}

export function SelfPacedIconBullets({
  activity,
}: {
  activity: SelfPacedIconInfoActivityType;
}) {
  const selfPacedIconInfo = useSelfPacedIconInfo(activity);
  return (
    <>
      <IconBullet
        icon={selfPacedIconInfo.numberOfLessons.icon}
        text={selfPacedIconInfo.numberOfLessons.text}
      />
      <IconBullet
        icon={selfPacedIconInfo.weeksOfFeedback.icon}
        text={selfPacedIconInfo.weeksOfFeedback.text}
      />
      <IconBullet
        icon={selfPacedIconInfo.chooseStartTime.icon}
        text={selfPacedIconInfo.chooseStartTime.text}
      />
      <IconBullet
        icon={selfPacedIconInfo.accessToContent.icon}
        text={selfPacedIconInfo.accessToContent.text}
      />
    </>
  );
}
